import KitchenPlanningPage from 'pages/demandplanning/kitchenplanning'
import React from 'react'

export default function KitchenPlanningView() {
  return <KitchenPlanningPage />
}
